import Vue from 'vue';

export const EventBus = new Vue();
export * as EventTypes from './event-types';
